import FeatherIcon from "feather-icons-react";
import { PRIMARY_KEY } from "@constants/app.constants";
import { formatDateUtil} from "@utils/date.util";
const keyColumn = PRIMARY_KEY;
const tableTitle = "Database Backup";
const menuUrl = "system/database-backup";

const renderBackupFilename = (name,handleBackupDownloadClick) =>{
  return (
  <a
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "#6259C8",
            }}
            onClick={()=>handleBackupDownloadClick(name)}
          >
            {name}
          </a>
  )
}
const tableColumn = ({ handleBackupDownloadClick }) => [
  {
    id: "file_name",
    numeric: false,
    disablePadding: true,
    label: "File name",
    formatData:(name ) => renderBackupFilename (name,handleBackupDownloadClick),
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDateUtil,
  },
];
const breadCrumbs = [
  { name: "System", menu_url: null },
  { name: "Database Backup", menu_url: "/system/database-backup" },
];

const filters = [
  {
    name: "file_name",
    id: "fileName",
    label: "File Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export { tableTitle, keyColumn, tableColumn, breadCrumbs, menuUrl, filters };
